import React, { Component } from 'react';
import { PulseLoader } from 'halogenium';
class CommonPulseLoader extends Component {
    render() {
        return (
            <PulseLoader color="#ffa733" size="10px" margin="4px" style={{ textAlign: "center" }} /> 
        );
    }
}

export default CommonPulseLoader;